import request from '../untils/request';

export const createQiniuTokenApi = params => {
  return request({
    url: '/common/home/get-qi-niu-token',
    params,
  });
};

export const commonDataExportApi = params => {
  return request({
    url: '/common/data-export/data-export',
    params,
  });
};

export const checkLoginStatusApi = params => {
  return request({
    url: '/common/home/check-login',
    params,
  });
};

export const systemUserInfoApi = params => {
  return request({
    url: '/system/user/user-info',
    params,
  });
};

export const getExpressListApi = params => {
  return request({
    url: '/order/order/get-express',
    params,
  });
};

export const checkExcelExport = params => {
  return request({
    url: '/common/data-export/data-export',
    params,
  });
};


export const getAppNames = params =>{
  return request({
    url: '/common/home/get-app-names',
    params,
  });
}